import { render, staticRenderFns } from "./AIChatWidgetPdpScenePicker.vue?vue&type=template&id=2935762c&scoped=true"
import script from "./AIChatWidgetPdpScenePicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpScenePicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpScenePicker.vue?vue&type=style&index=0&id=2935762c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935762c",
  null
  
)

export default component.exports